import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { COUNTRIES_DATA } from '../../../../fixtures/fixtures';
import { SubjectJsonModel } from '../subject.json.model';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'pixl-edit-subject-management',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    CommonModule,
    MatDividerModule,
  ],
  templateUrl: './edit-subject.component.html',
  styleUrl: './edit-subject.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditSubjectComponent {
  private readonly dialogRef = inject(MatDialogRef<EditSubjectComponent>);
  private fb = inject(FormBuilder);

  public data = inject<SubjectJsonModel>(MAT_DIALOG_DATA);
  public readonly countries: string[] = COUNTRIES_DATA;
  public subjectName = '';

  public formGroup: FormGroup = this.fb.group({
    name: [this.data.name, Validators.required],
    region: [this.data.region || '-1'],
  });

  public checkForErrors(formControl: AbstractControl): string {
    if (formControl.hasError('required')) {
      return 'Eingabe erforderlich';
    }

    return '';
  }

  public onSave(): void {
    if (this.formGroup.valid) {
      this.data.update(this.formGroup.value);
      this.dialogRef.close(this.data);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
